'use strict';

exports.__esModule = true;
exports.Horizontal_A = exports.Horizontal_XS = exports.Horizontal_S = exports.Horizontal_M = exports.Horizontal_L = exports.Horizontal_XL = exports.WF_HORIZONTAL_A = exports.WF_HORIZONTAL_XS = exports.WF_HORIZONTAL_S = exports.WF_HORIZONTAL_M = exports.WF_HORIZONTAL_L = exports.WF_HORIZONTAL_XL = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WF_HORIZONTAL_XL = exports.WF_HORIZONTAL_XL = 'WF_HORIZONTAL_XL';
var WF_HORIZONTAL_L = exports.WF_HORIZONTAL_L = 'WF_HORIZONTAL_L';
var WF_HORIZONTAL_M = exports.WF_HORIZONTAL_M = 'WF_HORIZONTAL_M';
var WF_HORIZONTAL_S = exports.WF_HORIZONTAL_S = 'WF_HORIZONTAL_S';
var WF_HORIZONTAL_XS = exports.WF_HORIZONTAL_XS = 'WF_HORIZONTAL_XS';
var WF_HORIZONTAL_A = exports.WF_HORIZONTAL_A = 'WF_HORIZONTAL_A';

var Horizontal_XL = exports.Horizontal_XL = function Horizontal_XL(props) {
    var reviewWordPostfix = props.totalReviews > 1 ? 's' : '';
    var bodyStyle = props.bodyStyle;
    var starsSize = props.starsSize;
    var logoSize = props.logoSize;

    return _react2.default.createElement(
        'div',
        { className: [_style2.default.container, _style2.default["container_xl"]].join(" ") },
        _react2.default.createElement(
            'a',
            {
                href: props.href,
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _style2.default['wrapper_transparent'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' ')
                },
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_start"], _style2.default["mr-1"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["our-customers-say"]].join(' ') },
                        'Our',
                        _react2.default.createElement('br', null),
                        'patients say:'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_middle"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default.mr, _style2.default["verbal-rating"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.VerbalRating, { rate: props.averageRating, isRateBold: true })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-sm"], _style2.default["stars"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating, size: starsSize })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-4"], _style2.default["big-text"], _style2.default["visible-md"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.NumericalRating, {
                            rate: props.averageRating,
                            isCountBold: true,
                            classNames: {
                                'numerical-rating-count': _style2.default["numerical-rating-count"]
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["big-text"], _style2.default["patients-reviews-count"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                            prefix: 'based on ',
                            reviewsCount: props.totalReviews,
                            postfix: " patient review" + reviewWordPostfix,
                            isCountBold: true,
                            classNames: {
                                'review-count__prefix': _style2.default["review-count__prefix"],
                                'review-count__counts': _style2.default["review-count__counts"]
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_end"], _style2.default["ml-1"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["doctify-logo"] },
                        _react2.default.createElement(
                            'div',
                            { className: _style2.default["logo-span"] },
                            'Verified by'
                        ),
                        _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                            logoSize: logoSize,
                            logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                            logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                        })
                    )
                )
            )
        )
    );
};

var Horizontal_L = exports.Horizontal_L = function Horizontal_L(props) {
    var reviewWordPostfix = props.totalReviews > 1 ? 's' : '';
    var bodyStyle = props.bodyStyle;
    var starsSize = props.starsSize;
    var logoSize = props.logoSize;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.container },
        _react2.default.createElement(
            'a',
            {
                href: props.href,
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _style2.default['wrapper_transparent'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' ')
                },
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_middle"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default.mr, _style2.default["verbal-rating"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.VerbalRating, { rate: props.averageRating, isRateBold: true })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-sm"], _style2.default["stars"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating, size: starsSize })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-4"], _style2.default["big-text"], _style2.default["numerical-rating"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.NumericalRating, {
                            rate: props.averageRating,
                            isCountBold: true,
                            classNames: {
                                'numerical-rating-count': _style2.default["numerical-rating-count"]
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["big-text"], _style2.default["patients-reviews-count"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                            prefix: 'based on ',
                            reviewsCount: props.totalReviews,
                            postfix: " patient review" + reviewWordPostfix,
                            isCountBold: true,
                            classNames: {
                                'review-count__prefix': _style2.default["review-count__prefix"],
                                'review-count__counts': _style2.default["review-count__counts"]
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_end"], _style2.default["ml-1"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["doctify-logo"] },
                        _react2.default.createElement(
                            'div',
                            { className: _style2.default["logo-span"] },
                            'Verified by'
                        ),
                        _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                            logoSize: logoSize,
                            logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                            logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                        })
                    )
                )
            )
        )
    );
};

var Horizontal_M = exports.Horizontal_M = function Horizontal_M(props) {
    var reviewWordPostfix = props.totalReviews > 1 ? 's' : '';
    var bodyStyle = props.bodyStyle;
    var starsSize = props.starsSize;
    var logoSize = props.logoSize;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.container },
        _react2.default.createElement(
            'a',
            {
                href: props.href,
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _style2.default['wrapper_transparent'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' ')
                },
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_middle"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-sm"], _style2.default["stars"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating, size: starsSize })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-4"], _style2.default["big-text"], _style2.default["numerical-rating"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.NumericalRating, {
                            rate: props.averageRating,
                            isCountBold: true,
                            classNames: {
                                'numerical-rating-count': _style2.default["numerical-rating-count"]
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["big-text"], _style2.default["patients-reviews-count"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                            prefix: 'based on ',
                            reviewsCount: props.totalReviews,
                            postfix: " patient review" + reviewWordPostfix,
                            isCountBold: true,
                            classNames: {
                                'review-count__prefix': _style2.default["review-count__prefix"],
                                'review-count__counts': _style2.default["review-count__counts"]
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_end"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["doctify-logo"] },
                        _react2.default.createElement(
                            'div',
                            { className: _style2.default["logo-span"] },
                            'Verified by'
                        ),
                        _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                            logoSize: logoSize,
                            logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                            logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                        })
                    )
                )
            )
        )
    );
};

var Horizontal_S = exports.Horizontal_S = function Horizontal_S(props) {
    var reviewWordPostfix = props.totalReviews > 1 ? 's' : '';
    var bodyStyle = props.bodyStyle;
    var starsSize = props.starsSize;
    var logoSize = props.logoSize;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.container },
        _react2.default.createElement(
            'a',
            {
                href: props.href,
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _style2.default['wrapper_transparent'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' ')
                },
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_middle"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["mr-sm"], _style2.default["stars"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating, size: starsSize })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["big-text"], _style2.default["patients-reviews-count"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                            reviewsCount: props.totalReviews,
                            postfix: " patient review" + reviewWordPostfix,
                            isCountBold: true,
                            classNames: {
                                'review-count__prefix': _style2.default["review-count__prefix"],
                                'review-count__counts': _style2.default["review-count__counts"]
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_end"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["doctify-logo"] },
                        _react2.default.createElement(
                            'div',
                            { className: _style2.default["logo-span"] },
                            'Verified by'
                        ),
                        _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                            logoSize: logoSize,
                            logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                            logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                        })
                    )
                )
            )
        )
    );
};

var Horizontal_XS = exports.Horizontal_XS = function Horizontal_XS(props) {
    var bodyStyle = props.bodyStyle;
    var starsSize = props.starsSize;
    var logoSize = props.logoSize;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.container },
        _react2.default.createElement(
            'a',
            {
                href: props.href,
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _style2.default['wrapper_transparent'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' ')
                },
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_middle"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["stars"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating, size: starsSize })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_end"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["doctify-logo"] },
                        _react2.default.createElement(
                            'div',
                            { className: _style2.default["logo-span"] },
                            'Verified by'
                        ),
                        _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                            logoSize: logoSize,
                            logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                            logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                        })
                    )
                )
            )
        )
    );
};

var Horizontal_A = exports.Horizontal_A = function Horizontal_A(props) {
    var bodyStyle = props.bodyStyle;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.container },
        _react2.default.createElement(
            'a',
            {
                href: props.href,
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, _style2.default["wrapper_a-layout"], bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _style2.default['wrapper_transparent'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' ')
                },
                _react2.default.createElement(
                    'div',
                    { className: [_style2.default["wrapper-item"], _style2.default["wrapper-item_a-layout"]].join(" ") },
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["doctify-logo"]].join(" ") },
                        _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                            logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_EXTRA_SMALL,
                            logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                            logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["ml-5"], _style2.default["mr-5"]].join(' ') },
                        _react2.default.createElement(_widgetsUtils.Stars, {
                            rate: props.averageRating,
                            isShrinked: true,
                            starItemClassNames: { 'stars-item--smaller': _style2.default['stars-item--smaller'] }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: [_style2.default["numerical-rating"], _style2.default["numerical-rating_smaller"], _style2.default["mb-neg-2"]].join(" ") },
                        _react2.default.createElement(_widgetsUtils.NumericalRating, {
                            rate: props.averageRating,
                            isCountBold: true,
                            isSlash: true
                        })
                    )
                )
            )
        )
    );
};